import { render, staticRenderFns } from "./ProductCustomization.vue?vue&type=template&id=9f3ea9a6&scoped=true&"
import script from "./ProductCustomization.vue?vue&type=script&lang=js&"
export * from "./ProductCustomization.vue?vue&type=script&lang=js&"
import style0 from "./ProductCustomization.vue?vue&type=style&index=0&id=9f3ea9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3ea9a6",
  null
  
)

export default component.exports